import React, { useEffect, useState } from 'react';

import { FaFileUpload } from 'react-icons/fa';

import { ClipLoader, BarLoader } from 'react-spinners';

import {
  ProgressUpload,
  IconCSV,
  BoxProgress,
  PercentageSize,
  ProgressLoading,
} from './styles';

import success_icon from '~/assets/img/sucess.svg';

export default function BoxProgressUpload({ fileName, loadingFile }) {
  const errorCompetence = null;
  const errorCnes = null;

  return (
    <ProgressUpload>
      <div className="bodyProgress">
        <IconCSV>
          <FaFileUpload color="#74a50a" size={52} />
          {/* <img src={cvs_icon} alt="Arquivo" />
          <img src={circle_icon} alt="Arquivo circle" /> */}
        </IconCSV>
        <BoxProgress errorCompetence={errorCompetence} errorCnes={errorCnes}>
          <div className="titleProgress">
            <div>{fileName || 'Arquivo carregado'}</div>
            <img src={success_icon} alt="Icon sucesso" />
          </div>

          {loadingFile ? (
            <div style={{ width: '100%', margin: '5px' }}>
              <BarLoader
                css={{ width: '288px' }}
                size={288}
                color="#74a50a"
                loading={loadingFile}
              />
            </div>
          ) : (
            <ProgressLoading
              errorCompetence={errorCompetence}
              errorCnes={errorCnes}
            />
          )}

          <PercentageSize>
            {loadingFile ? 'Enviando, aguarde...' : '100% carregado.'}{' '}
          </PercentageSize>
        </BoxProgress>
      </div>
    </ProgressUpload>
  );
}
